import React from 'react'
import { useAppDispatch, useAppSelector } from '@SonarCX/hooks/redux'

import Dropdown from '@SonarCX/components/atoms/Dropdown'

import { AddErrorAlert, AddSuccessAlert } from '@SonarCX/slices/alert'
import { selectTaskType } from '@SonarCX/slices/taskType'
import { useTaskAPI } from '@SonarCX/providers/TaskAPIProvider'
import useTaskPermissions from '@SonarCX/hooks/permissions/useTaskPermissions'
import useTaskInputOpen from '@SonarCX/hooks/useTaskInputOpen'
import useStyles from './styles'

const findType = (types, id) => {
  return types.find(type => type.id === id)?.name ?? 'Unassigned'
}

const Type = React.memo(({ task }) => {
  const dispatch = useAppDispatch()

  const { typesValues: types } = useAppSelector(selectTaskType)

  const { updateTask } = useTaskAPI()
  const { canEdit } = useTaskPermissions(task)
  const { isOpen, handleClick, handleClose } = useTaskInputOpen(task, 'TYPE')

  const [startingValue, setStartingValue] = React.useState(task.type_id)
  const [value, setValue] = React.useState(startingValue)

  const classes = useStyles({ canEdit })

  React.useEffect(() => {
    setStartingValue(task.type_id)
    setValue(task.type_id)
  }, [task.type_id])

  const handleSelect = React.useCallback(
    async value => {
      try {
        handleClose()
        if (startingValue === value) return
        const newTask = { ...task, type_id: value }
        await updateTask(newTask.id, newTask)
        setValue(value)
        dispatch(AddSuccessAlert('Changes saved'))
      } catch (err) {
        dispatch(AddErrorAlert({ err }))
      }
    },
    [handleClose, startingValue, task, updateTask, dispatch]
  )

  return (
    <div className={classes.root}>
      {isOpen && canEdit ? (
        <Dropdown
          options={types.map(type => type.id)}
          renderOption={id => findType(types, id)}
          selected={value}
          onSelect={handleSelect}
          onClose={handleClose}
          hideAdd
          stringOnly
          forceOpen
        >
          <div>{findType(types, value)}</div>
        </Dropdown>
      ) : (
        <div onClick={handleClick}>{findType(types, value)}</div>
      )}
    </div>
  )
})

export default Type
